module.exports = __webpack_public_path__ + "static/media/video1.092c6054.mp4";